import { render, staticRenderFns } from "./UnImpactTest.vue?vue&type=template&id=2516165d&"
import script from "./UnImpactTest.vue?vue&type=script&lang=js&"
export * from "./UnImpactTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports